// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html[dir=ltr] .QsfmIZI63qQHIsGnpDlL{margin-left:12px!important}html[dir=rtl] .QsfmIZI63qQHIsGnpDlL{margin-right:12px!important}html[dir] .UhijP4RCCrcP8AGFq6k9{border-radius:4px!important}.z431y7XUwV4Xa438bKxV{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%}html[dir] .rymTb2h87uMwU4sPtkEA{margin:0}.U7B9I6vfCQsxbCq2MlQS{display:-webkit-box;display:-ms-flexbox;display:flex;color:var(--white)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newMessageButtonMargins": "QsfmIZI63qQHIsGnpDlL",
	"newMessageButtonWithIcon": "UhijP4RCCrcP8AGFq6k9",
	"newMessageButtonWithDropDown": "z431y7XUwV4Xa438bKxV",
	"newSplitMessageButton": "rymTb2h87uMwU4sPtkEA",
	"newMessageButtonIcon": "U7B9I6vfCQsxbCq2MlQS"
};
module.exports = ___CSS_LOADER_EXPORT___;
